var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    'hide-chart': _vm.hideChart
  },attrs:{"id":"chart"}},[_c('action-links',{attrs:{"textAlign":"right"}},[_c('Button',{attrs:{"text":_vm.hideChart ? 'Show Chart' : 'Hide Chart'},on:{"click":_vm.toggleChart}})],1),_c('highchart',{ref:"chart",attrs:{"width":_vm.width,"height":_vm.height,"options":_vm.options}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }